import { EntityInput, forCreate, forDelete, forUpdate } from '../common/entity';
import { ProductMasterDataExportConfiguration } from './productMasterDataExportConfiguration';

export class ProductMasterDataExportConfigurationInput
  extends ProductMasterDataExportConfiguration
  implements EntityInput<ProductMasterDataExportConfiguration>
{
  forCreate(): CreateProductMasterDataExportConfigurationInput {
    return CreateProductMasterDataExportConfigurationInput.from(
      { ...this, mapping: Object.fromEntries(this.mapping) },
      CreateProductMasterDataExportConfigurationInput,
    );
  }

  forUpdate(): UpdateProductMasterDataExportConfigurationInput {
    return UpdateProductMasterDataExportConfigurationInput.from(
      { ...this, mapping: Object.fromEntries(this.mapping) },
      UpdateProductMasterDataExportConfigurationInput,
    );
  }

  forDelete(): DeleteProductMasterDataExportConfigurationInput {
    return DeleteProductMasterDataExportConfigurationInput.from(this, DeleteProductMasterDataExportConfigurationInput);
  }
}

export class CreateProductMasterDataExportConfigurationInput extends forCreate(ProductMasterDataExportConfiguration) {}

export class UpdateProductMasterDataExportConfigurationInput extends forUpdate(ProductMasterDataExportConfiguration) {}

export class DeleteProductMasterDataExportConfigurationInput extends forDelete(ProductMasterDataExportConfiguration) {}
